// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-of-use-header[data-v-d16d6306] {
  width: 100%;
  text-align: center;
  font-family: "Poppins", sans-serif;
  color: #495057;
}
.terms-of-use-header__title[data-v-d16d6306] {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: inherit;
}
.terms-of-use-header__subtitle[data-v-d16d6306] {
  margin: 4px 0 0;
  font-size: 14px;
  color: #757575;
}
.terms-of-use-body[data-v-d16d6306] {
  width: 100%;
  text-align: left;
}
.terms-of-use-footer[data-v-d16d6306] {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  font-family: "Poppins", sans-serif;
}
@media (max-width: 575.98px) {
.terms-of-use-footer[data-v-d16d6306] {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
}
.terms-of-use-footer .terms-of-use-footer__button[data-v-d16d6306] {
    width: 100%;
}
}
.terms-of-use-footer__checkbox[data-v-d16d6306] {
  color: #374151;
}
.terms-of-use-footer__checkbox[data-v-d16d6306] .custom-control-label {
  font-family: inherit;
  font-weight: 500;
  font-size: 14px;
  color: inherit;
  padding-left: 8px;
}
.terms-of-use-footer__checkbox[data-v-d16d6306] .custom-control-label::before,
.terms-of-use-footer__checkbox[data-v-d16d6306] .custom-control-label::after {
  width: 18px;
  height: 18px;
  top: 1.5px;
}
.terms-of-use-footer__button[data-v-d16d6306] {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-family: inherit;
  font-weight: 500;
  background-color: #53933a;
  border-color: #53933a;
  color: #fff;
}
.terms-of-use-footer__button[data-v-d16d6306]:hover:not(:disabled) {
  background-color: #467a30;
  border-color: #467a30;
  color: #fff;
}
.terms-of-use-footer__button[data-v-d16d6306]:disabled {
  background-color: #53933a;
  border-color: #53933a;
  opacity: 0.5;
  cursor: not-allowed;
}
.terms-of-use-footer__button[data-v-d16d6306]:hover:disabled {
  background-color: #53933a;
  border-color: #53933a;
  color: #fff;
  cursor: not-allowed;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
